import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { CardsModule, IMyDate, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import dayjs from 'dayjs';

import { User } from '../../../../../models/user.model';
import { PATHS } from 'models/bary-paths.model';
import { PositionEnum } from '../../../../../models/enums/position.enum';
import { LIST_POSITION } from '../../../../../models/position.model';
import { CIVILITIES_OPTIONS } from 'models/enums/civilities-option.enum';

import { UserTypeEnum } from '../../../../../models/enums/user-type.enum';
import {
  BaryButtonComponent,
  BaryCardComponent,
  BaryInputEmailComponent,
  BaryInputPasswordComponent,
  BaryInputPhoneComponent,
  BaryInputSelectComponent,
  BaryInputTextComponent, CivilityNamePipe
} from '../../../components';

import { TranslateDirective } from '../../../../../directives/translate.directive';

import { BaryDatePickerComponent } from '../../../components/bary-date-picker/bary-date-picker.component';

import { PhoneFormatPipe } from '../../../../pipes/phone.pipe';

@Component({
  selector: 'jhi-user-card',
  standalone: true,
  imports: [
    BaryInputTextComponent,
    BaryInputSelectComponent,
    TranslateModule,
    BaryButtonComponent,
    TranslateDirective,
    BaryCardComponent,
    BaryInputPhoneComponent,
    BaryDatePickerComponent,
    BaryInputEmailComponent,
    BaryInputPasswordComponent,
    DatePipe,
    PhoneFormatPipe,
    CardsModule,
    ReactiveFormsModule,
    CommonModule,
    MDBBootstrapModulesPro,
    CivilityNamePipe
  ],
  templateUrl: './user-card.component.html',
})
export class UserCardComponent {
  readonly #translateService = inject(TranslateService);

  public readonly CIVILITIES_OPTIONS = CIVILITIES_OPTIONS;

  public DEFAULT_OPTIONS = {
    minDate: { year: 1900, month: 1, day: 1 } as IMyDate,
    maxDate: { year: dayjs().year(), month: dayjs().month() + 1, day: dayjs().date() } as IMyDate,
  };
  public PATHS = PATHS;

  @Input() baryForm!: FormGroup;
  @Input() description?: string;
  @Input() register: boolean = false;
  @Input() isBaryUser: boolean = true;
  @Input() touched: boolean = false;
  @Input() isEditMode: boolean = true;
  @Input() user?: User;
  @Input() switchButton = false;

  @Output() action = new EventEmitter<boolean>();

  public positionCompanyOptions = [
    LIST_POSITION[PositionEnum.COMPANY_DIRECTOR],
    LIST_POSITION[PositionEnum.COMPANY_HUMAN_RESOURCE_MANAGER],
    LIST_POSITION[PositionEnum.COMPANY_ACCOUNTANT],
    LIST_POSITION[PositionEnum.COMPANY_SALES_ADMINISTRATOR],
    LIST_POSITION[PositionEnum.COMPANY_MARKETING_MANAGER],
    LIST_POSITION[PositionEnum.COMPANY_IT_MANAGER],
    LIST_POSITION[PositionEnum.COMPANY_COMMERCIAL],
    LIST_POSITION[PositionEnum.COMPANY_CUSTOMER_SUCCESS],
    LIST_POSITION[PositionEnum.COMPANY_OPERATIONAL],
    LIST_POSITION[PositionEnum.OTHER],
    ].map(val => ({ label: this.#translateService.instant(val.labelKey)!, value: val.code}))

  public positionAssociationOptions = [
    LIST_POSITION[PositionEnum.ASSOCIATION_PRESIDENT],
    LIST_POSITION[PositionEnum.ASSOCIATION_ACCOUNTANT],
    LIST_POSITION[PositionEnum.COMPANY_ACCOUNTANT],
    LIST_POSITION[PositionEnum.OTHER],
  ].map(val => ({ label: this.#translateService.instant(val.labelKey)!, value: val.code}))

  public get userForm(): FormGroup {
    return this.baryForm.get('userForm') as FormGroup;
  }

  public getControl(name: string): FormControl {
    return this.userForm.get(name) as FormControl;
  }

  public isIndividual(): boolean {
    return this.getControl('userType').value === UserTypeEnum.INDIVIDUAL;
  }

  public getPosition(): { label: string; value: PositionEnum }[] {
    return this.getControl('userType').value === UserTypeEnum.COMPANY ? this.positionCompanyOptions : this.positionAssociationOptions;
  }

  /**
   * Hack: Je n'arrive pas utiliser le CivilityPipe dans ce composant
   */
  public getCivility(): string {
    return this.CIVILITIES_OPTIONS.find(it => it.value === this.user?.civility)?.label ?? '';
  }
}
